export default {
  // 搜索区
  batchSn: '码批次',
  batchSnPlaceholder: '请输入码批次号',
  codeSn: '流水号',
  codeSnPlaceholder: '请输入流水号',
  productName: '产品名称',
  productNamePlaceholder: '请输入产品名称',
  memberId: '用户ID',
  memberIdPlaceholder: '请输入用户ID',
  memberName: '用户昵称',
  memberNamePlaceholder: '请输入用户昵称',
  region: '扫码国家/地区',
  regionPlaceholder: '请选择',
  isRepetition: '扫码次数',
  isRepetitionPlaceholder: '请选择',
  firstScan: '首次',
  repeatedScan: '重复扫码',
  qrcodeType: '二维码类型',
  qrcodeTypePlaceholder: '请选择',
  qrcodeTypeBig: '大标',
  qrcodeTypeMid: '中标',
  qrcodeTypeSmall: '小标',
  qrcodeTypeAntiFake: '防伪',
  scanTime: '扫码时间',
  startTime: '开始时间',
  endTime: '结束时间',
  colBatchNo: '二维码批次',
  // 操作按钮
  export: '导出',
  // 表格列
  colQrcode: '二维码',
  colScanCount: '被查询次数',
  colUserInfo: '用户信息',
  colProductInfo: '产品信息',
  colScanTime: '扫码时间',
  colScanRegion: '扫码地区',
  colScanIp: '扫码IP',
  // 被查询次数
  nthScan: '第{count}次',
  // 空状态
  emptyText: '暂无扫码记录',
};
